import type { ComponentProps, TextSlots, TextState } from '@fluentui/react-components';

export type TimestampSlots = {
  root: TextSlots['root'];
};

/**
 * Timestamp Props
 */
export type TimestampProps = ComponentProps<TimestampSlots> & {};

/**
 * State used in rendering Timestamp
 */
export type TimestampState = TextState & {};
